import { useContext, useMemo } from 'react';

import { FlagsContext } from 'src/context';
import { useAppSelector } from 'src/hooks/useStore';
import { UnreadViewer } from 'src/utils/MessagingUtils';

/**
 * Builds an `UnreadViewer` describing the current user's perspective on unread
 * messaging state. IU/client classification is decided from `state.user.isClient`;
 * authorship of individual messages is identified via each message's GetStream
 * role in `getDerivedChannelUnreadCount`.
 *
 * The IU-to-IU suppression behavior is gated behind the
 * `EnableMessageAppNotification` flag. When the flag is off, `isInternalUser`
 * is reported as `false` so every helper falls through to native GetStream
 * behavior regardless of viewer type.
 */
export const useUnreadMessageViewer = (): UnreadViewer => {
  const viewerGetstreamId = useAppSelector(
    (state) => state.user.data?.getstreamId,
  );
  const isClient = useAppSelector((state) => state.user.isClient);
  const { EnableMessageAppNotification } = useContext(FlagsContext);
  return useMemo(
    () => ({
      viewerGetstreamId,
      isInternalUser: !isClient && EnableMessageAppNotification,
    }),
    [viewerGetstreamId, isClient, EnableMessageAppNotification],
  );
};
